{
  "REPORT": {
    "HEADER": "Các cuộc hội thoại",
    "LOADING_CHART": "Đang tải các biểu đồ dữ liệu...",
    "NO_ENOUGH_DATA": "Chúng tôi không nhận được đủ điểm dữ liệu để tạo báo cáo, Vui lòng thử lại sau.",
    "DOWNLOAD_AGENT_REPORTS": "Tải xuống báo cáo tổng đài viên",
    "DATA_FETCHING_FAILED": "Failed to fetch data, please try again later.",
    "SUMMARY_FETCHING_FAILED": "Failed to fetch summary, please try again later.",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Các cuộc trò chuyện",
        "DESC": "( Tổng cộng )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Tin nhắn nhận được",
        "DESC": "( Tổng cộng )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Tin nhắn gửi đi",
        "DESC": "( Tổng cộng )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Thời gian phản hồi đầu tiên",
        "DESC": "( Trung bình )",
        "INFO_TEXT": "Tổng số cuộc hội thoại được sử dụng để tính toán:",
        "TOOLTIP_TEXT": "Thời gian phản hồi đầu tiên là {metricValue} (dựa trên {conversationCount} cuộc hội thoại)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Thời gian giải quyết",
        "DESC": "( Trung bình )",
        "INFO_TEXT": "Tổng số cuộc hội thoại được sử dụng để tính toán:",
        "TOOLTIP_TEXT": "Thời gian giải quyết là {metricValue} (dựa trên {conversationCount} hội thoại)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Số lượng giải quyết",
        "DESC": "( Tổng cộng )"
      },
      "BOT_RESOLUTION_COUNT": {
        "NAME": "Số lượng giải quyết",
        "DESC": "( Tổng cộng )"
      },
      "BOT_HANDOFF_COUNT": {
        "NAME": "Handoff Count",
        "DESC": "( Tổng cộng )"
      },
      "REPLY_TIME": {
        "NAME": "Customer waiting time",
        "TOOLTIP_TEXT": "Waiting time is {metricValue} (based on {conversationCount} replies)",
        "DESC": ""
      }
    },
    "DATE_RANGE_OPTIONS": {
      "TODAY": "Hôm nay",
      "YESTERDAY": "Hôm qua",
      "LAST_7_DAYS": "7 ngày cuối",
      "LAST_30_DAYS": "30 ngày cuối",
      "THIS_MONTH": "Tháng này",
      "LAST_MONTH": "Tháng trước",
      "LAST_3_MONTHS": "3 tháng vừa qua",
      "LAST_6_MONTHS": "6 tháng vừa qua",
      "LAST_YEAR": "Năm ngoái",
      "CUSTOM_DATE_RANGE": "Phạm vi ngày tùy chỉnh"
    },
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Áp dụng",
      "PLACEHOLDER": "Chọn phạm vi ngày"
    },
    "GROUP_BY_FILTER_DROPDOWN_LABEL": "Nhóm theo",
    "DURATION_FILTER_LABEL": "Thời lượng",
    "GROUPING_OPTIONS": {
      "DAY": "Ngày",
      "WEEK": "Tuần",
      "MONTH": "Tháng",
      "YEAR": "Năm"
    },
    "GROUP_BY_DAY_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Ngày"
      }
    ],
    "GROUP_BY_WEEK_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Ngày"
      },
      {
        "id": 2,
        "groupBy": "Tuần"
      }
    ],
    "GROUP_BY_MONTH_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Ngày"
      },
      {
        "id": 2,
        "groupBy": "Tuần"
      },
      {
        "id": 3,
        "groupBy": "Tháng"
      }
    ],
    "GROUP_BY_YEAR_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Ngày"
      },
      {
        "id": 2,
        "groupBy": "Tuần"
      },
      {
        "id": 3,
        "groupBy": "Tháng"
      }
    ],
    "BUSINESS_HOURS": "Giờ làm việc",
    "FILTER_ACTIONS": {
      "CLEAR_FILTER": "Clear filter",
      "EMPTY_LIST": "Không tìm thấy kết quả"
    },
    "DRILLDOWN": {
      "RESULT_COUNT_CONVERSATION": "Cuộc trò chuyện: {count}",
      "RESULT_COUNT_MESSAGE": "Tin nhắn: {count}",
      "EMPTY": "Không tìm thấy bản ghi nào cho cột này.",
      "ERROR": "Không thể tải bản ghi. Vui lòng thử lại.",
      "LOAD_MORE": "Tải thêm",
      "PREVIOUS_BUCKET": "Cột trước",
      "NEXT_BUCKET": "Cột tiếp theo",
      "UNKNOWN_CONTACT": "Liên hệ không xác định",
      "UNKNOWN_INBOX": "Hộp thư đến không xác định",
      "UNASSIGNED_AGENT": "Chưa được giao",
      "NO_MESSAGE_CONTENT": "Không có nội dung tin nhắn",
      "MESSAGE_CREATED_AT": "Tin nhắn được tạo lúc {time}",
      "EVENT_OCCURRED_AT": "Sự kiện xảy ra lúc {time}",
      "INCOMING_MESSAGE": "Tin nhắn đến",
      "OUTGOING_MESSAGE": "Tin nhắn đi",
      "VIEW_ALL": "Xem trong cuộc trò chuyện",
      "VIEW_ALL_LIMIT": "Chỉ các cột có tối đa {limit} cuộc trò chuyện mới mở được trong danh sách cuộc trò chuyện.",
      "HIDDEN_COUNT": "Không hiển thị vì bạn không phải thành viên hộp thư đến của chúng: {count}"
    },
    "PAGINATION": {
      "RESULTS": "Showing {start} to {end} of {total} results",
      "PER_PAGE_TEMPLATE": "{size} / page"
    }
  },
  "AGENT_REPORTS": {
    "HEADER": "Tổng quan đại lý",
    "DESCRIPTION": "Easily track agent performance with key metrics such as conversations, response times, resolution times, and resolved cases. Click an agent’s name to learn more.",
    "LOADING_CHART": "Đang tải các biểu đồ dữ liệu...",
    "NO_ENOUGH_DATA": "Chúng tôi không nhận được đủ điểm dữ liệu để tạo báo cáo, Vui lòng thử lại sau.",
    "DOWNLOAD_AGENT_REPORTS": "Tải xuống báo cáo đại lý",
    "FILTER_DROPDOWN_LABEL": "Chọn đại lý",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Các cuộc hội thoại",
        "DESC": "( Tổng cộng )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Tin nhắn nhận được",
        "DESC": "( Tổng cộng )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Tin nhắn gửi đi",
        "DESC": "( Tổng cộng )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Thời gian phản hồi đầu tiên",
        "DESC": "( Trung bình )",
        "INFO_TEXT": "Tổng số cuộc hội thoại được sử dụng để tính toán:",
        "TOOLTIP_TEXT": "Thời gian phản hồi đầu tiên là {metricValue} (dựa trên {conversationCount} cuộc hội thoại)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Thời gian giải quyết",
        "DESC": "( Trung bình )",
        "INFO_TEXT": "Tổng số cuộc hội thoại được sử dụng để tính toán:",
        "TOOLTIP_TEXT": "Thời gian giải quyết là {metricValue} (dựa trên {conversationCount} hội thoại)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Số lượng giải quyết",
        "DESC": "( Tổng cộng )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "7 ngày cuối"
      },
      {
        "id": 1,
        "name": "30 ngày cuối"
      },
      {
        "id": 2,
        "name": "3 tháng vừa qua"
      },
      {
        "id": 3,
        "name": "6 tháng vừa qua"
      },
      {
        "id": 4,
        "name": "Năm ngoái"
      },
      {
        "id": 5,
        "name": "Phạm vi ngày tùy chỉnh"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Áp dụng",
      "PLACEHOLDER": "Chọn phạm vi ngày"
    }
  },
  "LABEL_REPORTS": {
    "HEADER": "Tổng quan nhãn",
    "DESCRIPTION": "Theo dõi hiệu suất của nhãn với các chỉ số chính, bao gồm cuộc trò chuyện, thời gian phản hồi, thời gian giải quyết và các trường hợp đã giải quyết.",
    "LOADING_CHART": "Đang tải các biểu đồ dữ liệu...",
    "NO_ENOUGH_DATA": "Chúng tôi không nhận được đủ điểm dữ liệu để tạo báo cáo, Vui lòng thử lại sau.",
    "DOWNLOAD_LABEL_REPORTS": "Tải xuống báo cáo nhãn",
    "FILTER_DROPDOWN_LABEL": "Chọn Nhãn",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Các cuộc hội thoại",
        "DESC": "( Tổng cộng )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Tin nhắn nhận được",
        "DESC": "( Tổng cộng )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Tin nhắn gửi đi",
        "DESC": "( Tổng cộng )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Thời gian phản hồi đầu tiên",
        "DESC": "( Trung bình )",
        "INFO_TEXT": "Tổng số cuộc hội thoại được sử dụng để tính toán:",
        "TOOLTIP_TEXT": "Thời gian phản hồi đầu tiên là {metricValue} (dựa trên {conversationCount} cuộc hội thoại)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Thời gian giải quyết",
        "DESC": "( Trung bình )",
        "INFO_TEXT": "Tổng số cuộc hội thoại được sử dụng để tính toán:",
        "TOOLTIP_TEXT": "Thời gian giải quyết là {metricValue} (dựa trên {conversationCount} hội thoại)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Số lượng giải quyết",
        "DESC": "( Tổng cộng )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "7 ngày cuối"
      },
      {
        "id": 1,
        "name": "30 ngày cuối"
      },
      {
        "id": 2,
        "name": "3 tháng vừa qua"
      },
      {
        "id": 3,
        "name": "6 tháng vừa qua"
      },
      {
        "id": 4,
        "name": "Năm ngoái"
      },
      {
        "id": 5,
        "name": "Phạm vi ngày tùy chỉnh"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Áp dụng",
      "PLACEHOLDER": "Chọn phạm vi ngày"
    }
  },
  "INBOX_REPORTS": {
    "HEADER": "Tổng quan hộp thư đến",
    "DESCRIPTION": "Quickly view your inbox performance with key metrics like conversations, response times, resolution times, and resolved cases—all in one place. Click an inbox name for more details.",
    "LOADING_CHART": "Đang tải các biểu đồ dữ liệu...",
    "NO_ENOUGH_DATA": "Chúng tôi không nhận được đủ điểm dữ liệu để tạo báo cáo, Vui lòng thử lại sau.",
    "DOWNLOAD_INBOX_REPORTS": "Tải xuống báo cáo hộp thư đến",
    "FILTER_DROPDOWN_LABEL": "Chọn Hộp thư đến",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Các cuộc hội thoại",
        "DESC": "( Tổng cộng )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Tin nhắn nhận được",
        "DESC": "( Tổng cộng )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Tin nhắn gửi đi",
        "DESC": "( Tổng cộng )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Thời gian phản hồi đầu tiên",
        "DESC": "( Trung bình )",
        "INFO_TEXT": "Tổng số cuộc hội thoại được sử dụng để tính toán:",
        "TOOLTIP_TEXT": "Thời gian phản hồi đầu tiên là {metricValue} (dựa trên {conversationCount} cuộc hội thoại)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Thời gian giải quyết",
        "DESC": "( Trung bình )",
        "INFO_TEXT": "Tổng số cuộc hội thoại được sử dụng để tính toán:",
        "TOOLTIP_TEXT": "Thời gian giải quyết là {metricValue} (dựa trên {conversationCount} hội thoại)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Số lượng giải quyết",
        "DESC": "( Tổng cộng )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "7 ngày cuối"
      },
      {
        "id": 1,
        "name": "30 ngày cuối"
      },
      {
        "id": 2,
        "name": "3 tháng vừa qua"
      },
      {
        "id": 3,
        "name": "6 tháng vừa qua"
      },
      {
        "id": 4,
        "name": "Năm ngoái"
      },
      {
        "id": 5,
        "name": "Phạm vi ngày tùy chỉnh"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Áp dụng",
      "PLACEHOLDER": "Chọn phạm vi ngày"
    }
  },
  "TEAM_REPORTS": {
    "HEADER": "Tổng quan nhóm",
    "DESCRIPTION": "Get a snapshot of your team’s performance with essential metrics, including conversations, response times, resolution times, and resolved cases. Click a team name for more details.",
    "LOADING_CHART": "Đang tải các biểu đồ dữ liệu...",
    "NO_ENOUGH_DATA": "Chúng tôi không nhận được đủ điểm dữ liệu để tạo báo cáo, Vui lòng thử lại sau.",
    "DOWNLOAD_TEAM_REPORTS": "Tải xuống báo cáo nhóm",
    "FILTER_DROPDOWN_LABEL": "Chọn nhóm",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Các cuộc hội thoại",
        "DESC": "( Tổng cộng )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Tin nhắn nhận được",
        "DESC": "( Tổng cộng )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Tin nhắn gửi đi",
        "DESC": "( Tổng cộng )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Thời gian phản hồi đầu tiên",
        "DESC": "( Trung bình )",
        "INFO_TEXT": "Tổng số cuộc hội thoại được sử dụng để tính toán:",
        "TOOLTIP_TEXT": "Thời gian phản hồi đầu tiên là {metricValue} (dựa trên {conversationCount} cuộc hội thoại)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Thời gian giải quyết",
        "DESC": "( Trung bình )",
        "INFO_TEXT": "Tổng số cuộc hội thoại được sử dụng để tính toán:",
        "TOOLTIP_TEXT": "Thời gian giải quyết là {metricValue} (dựa trên {conversationCount} hội thoại)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Số lượng giải quyết",
        "DESC": "( Tổng cộng )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "7 ngày cuối"
      },
      {
        "id": 1,
        "name": "30 ngày cuối"
      },
      {
        "id": 2,
        "name": "3 tháng vừa qua"
      },
      {
        "id": 3,
        "name": "6 tháng vừa qua"
      },
      {
        "id": 4,
        "name": "Năm ngoái"
      },
      {
        "id": 5,
        "name": "Phạm vi ngày tùy chỉnh"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Áp dụng",
      "PLACEHOLDER": "Chọn phạm vi ngày"
    }
  },
  "CSAT_REPORTS": {
    "HEADER": "Báo cáo CSAT",
    "NO_RECORDS": "Không có phản hồi báo cáo CSAT có sẵn.",
    "DOWNLOAD": "Tải về các báo cáo CSAT",
    "DOWNLOAD_FAILED": "Failed to download CSAT Reports",
    "FILTERS": {
      "AGENTS": {
        "PLACEHOLDER": "Chọn tổng đài viên"
      }
    },
    "TABLE": {
      "HEADER": {
        "CONTACT_NAME": "Liên hệ",
        "AGENT_NAME": "Đại lý được phân công",
        "RATING": "Đánh giá",
        "FEEDBACK_TEXT": "Bình luận phản hồi"
      }
    },
    "METRIC": {
      "TOTAL_RESPONSES": {
        "LABEL": "Tổng số phản hồi",
        "TOOLTIP": "Tổng số phản hồi thu thập được"
      },
      "SATISFACTION_SCORE": {
        "LABEL": "Mức độ hài lòng",
        "TOOLTIP": "Tổng số phản hồi tích cực / Tổng số phản hồi * 100"
      },
      "RESPONSE_RATE": {
        "LABEL": "Tỷ lệ phản hồi",
        "TOOLTIP": "Tổng số phản hồi / Tổng số tin nhắn khảo sát CSAT đã gửi * 100"
      }
    }
  },
  "BOT_REPORTS": {
    "HEADER": "Bot Reports",
    "METRIC": {
      "CONVERSATION_COUNT": {
        "LABEL": "Số lượng cuộc hội thoại",
        "TOOLTIP": "Tổng số cuộc hội thoại có tin nhắn của bot"
      },
      "OUTGOING_COUNT": {
        "LABEL": "Số lượng câu trả lời",
        "TOOLTIP": "Tổng số tin nhắn đi"
      },
      "MESSAGE_COUNT": {
        "LABEL": "Số lượng câu trả lời AI",
        "TOOLTIP": "Tổng số tin nhắn trả lời do bot gửi"
      },
      "COPILOT_COUNT": {
        "LABEL": "Số lượng phản hồi đã chuẩn bị",
        "TOOLTIP": "Tổng số gợi ý copilot mà bot chuẩn bị cho tổng đài viên"
      },
      "SUCCESS_RATE": {
        "LABEL": "Được AI giải quyết",
        "TOOLTIP": "Tỷ lệ phần trăm cuộc hội thoại được AI giải quyết mà không cần chuyển cho tổng đài viên"
      },
      "RESOLVE_TIME": {
        "LABEL": "Thời gian giải quyết",
        "TOOLTIP": "Thời gian trung vị từ tin nhắn đầu tiên của khách hàng đến tin nhắn cuối cùng của bot/tổng đài viên"
      },
      "TOTAL_CONVERSATIONS": {
        "LABEL": "No. of Conversations",
        "TOOLTIP": "Total number of conversations handled by the bot"
      },
      "TOTAL_RESPONSES": {
        "LABEL": "Total Responses",
        "TOOLTIP": "Total number of responses sent by the bot"
      },
      "RESOLUTION_RATE": {
        "LABEL": "Resolution Rate",
        "TOOLTIP": "Total number of conversations resolved by the bot / Total number of conversations handled by the bot * 100"
      },
      "HANDOFF_RATE": {
        "LABEL": "Handoff Rate",
        "TOOLTIP": "Total number of conversations handed off to agents / Total number of conversations handled by the bot * 100"
      }
    },
    "GROUP_BY": {
      "NONE": "Không nhóm",
      "INBOXES": "Hộp thư đến",
      "LABELS": "Nhãn"
    },
    "GROUPED": {
      "CHART_TITLE": "Phân bổ theo nhóm",
      "BACK_TO_ALL": "Hiện tất cả",
      "TABLE": {
        "INBOX": "Hộp thư đến",
        "LABEL": "Nhãn",
        "CONVERSATIONS": "Cuộc hội thoại",
        "MESSAGES": "Tin nhắn",
        "MESSAGES_TOOLTIP": "Tổng số tin nhắn đi",
        "AI_MESSAGES": "Câu trả lời AI",
        "AI_MESSAGES_TOOLTIP": "Tổng số câu trả lời AI, kèm theo số lượt đánh giá tích cực và tiêu cực của người dùng cuối",
        "THUMBS_UP_TOOLTIP": "Số câu trả lời AI được người dùng cuối đánh giá tích cực (thích)",
        "THUMBS_DOWN_TOOLTIP": "Số câu trả lời AI được người dùng cuối đánh giá tiêu cực (không thích)",
        "PREPARED": "Câu trả lời đã chuẩn bị",
        "PERCENTAGE": "%",
        "PERCENTAGE_TOOLTIP": "Tỷ lệ phần trăm tin nhắn của nhóm này trong tổng số tin nhắn",
        "BOT_RESPONSES": "% Câu trả lời AI",
        "SUGGESTION_USED": "Câu trả lời đã dùng",
        "SUGGESTION_USED_TOOLTIP": "Tỷ lệ phần trăm câu trả lời đã chuẩn bị trong nhóm này được tổng đài viên sử dụng",
        "SUGGESTION_NOT_USED": "Câu trả lời chưa dùng",
        "SUGGESTION_NOT_USED_TOOLTIP": "Tỷ lệ phần trăm tin nhắn trong nhóm này có phản hồi đã chuẩn bị nhưng không được sử dụng"
      },
      "NOTES": {
        "TITLE": "Cách các chỉ số được tính toán",
        "CONVERSATIONS": "Số cuộc hội thoại có ít nhất một tin nhắn đi trong khoảng thời gian đã chọn.",
        "MESSAGES": "Tổng số tin nhắn đi (không riêng tư) được gửi trong khoảng thời gian đã chọn. Bao gồm cả tin nhắn do AI tạo ra và do con người viết.",
        "PERCENTAGE": "Tỷ trọng tin nhắn của nhóm này trong tổng số tin nhắn đi của tất cả các nhóm.",
        "AI_MESSAGES": "Số tin nhắn đi được bot AI tự động gửi (không bao gồm các phản hồi đã chuẩn bị cho tổng đài viên). Các số trong ngoặc đơn cho biết có bao nhiêu câu trả lời được người dùng cuối đánh giá tích cực (thích) và tiêu cực (không thích).",
        "PREPARED": "Số gợi ý copilot (phản hồi đã chuẩn bị) do bot AI tạo cho tổng đài viên trong khoảng thời gian đã chọn. Đây là các tin nhắn riêng tư chỉ tổng đài viên nhìn thấy và không được tính là tin nhắn đi, vì vậy con số này có thể không khớp với cột Tin nhắn.",
        "SUGGESTION_USED": "Tỷ lệ phần trăm câu trả lời đã chuẩn bị trong nhóm này được tổng đài viên sử dụng. Tỷ lệ này có thể không khớp với số Câu trả lời đã chuẩn bị vì có thể bao gồm cả các gợi ý được tạo ở các khoảng thời gian trước.",
        "SUGGESTION_NOT_USED": "Tỷ lệ phần trăm tin nhắn đi trong nhóm này có gợi ý copilot khả dụng nhưng tổng đài viên trả lời mà không sử dụng. Chỉ được tính khi tổng đài viên thực sự gửi phản hồi. Tỷ lệ này có thể không khớp với số Câu trả lời đã chuẩn bị vì có thể bao gồm cả các gợi ý được tạo ở các khoảng thời gian trước."
      }
    }
  },
  "OVERVIEW_REPORTS": {
    "HEADER": "Tổng quan",
    "LIVE": "Trực tuyến",
    "ACCOUNT_CONVERSATIONS": {
      "HEADER": "Mở cuộc hội thoại",
      "LOADING_MESSAGE": "Đang tải số liệu cuộc hội thoại...",
      "OPEN": "Mở",
      "UNATTENDED": "Không giám sát",
      "UNASSIGNED": "Chưa được phân công",
      "PENDING": "Chờ giải quyết"
    },
    "CONVERSATION_HEATMAP": {
      "HEADER": "Conversation Traffic",
      "NO_CONVERSATIONS": "No conversations",
      "CONVERSATION": "{count} conversation",
      "CONVERSATIONS": "{count} conversations",
      "DOWNLOAD_REPORT": "Download report"
    },
    "AGENT_CONVERSATIONS": {
      "HEADER": "Cuộc hội thoại của các tổng đài viên",
      "LOADING_MESSAGE": "Đang tải chỉ số tổng đài viên...",
      "NO_AGENTS": "Không có cuộc hội thoại nào của các tổng đài viên",
      "TABLE_HEADER": {
        "AGENT": "Nhà cung cấp",
        "OPEN": "Mở",
        "UNATTENDED": "Không giám sát",
        "STATUS": "Trạng thái"
      }
    },
    "TEAM_CONVERSATIONS": {
      "ALL_TEAMS": "All Teams",
      "HEADER": "Conversations by teams",
      "LOADING_MESSAGE": "Loading team metrics...",
      "NO_TEAMS": "There is no data available",
      "TABLE_HEADER": {
        "TEAM": "Nhóm",
        "OPEN": "Mở",
        "UNATTENDED": "Không giám sát",
        "STATUS": "Trạng thái"
      }
    },
    "AGENT_STATUS": {
      "HEADER": "Trạng thái tổng đài viên",
      "ONLINE": "Trực Tuyến",
      "BUSY": "Bận",
      "OFFLINE": "Không Trực Tuyến"
    }
  },
  "DAYS_OF_WEEK": {
    "SUNDAY": "Sunday",
    "MONDAY": "Monday",
    "TUESDAY": "Tuesday",
    "WEDNESDAY": "Wednesday",
    "THURSDAY": "Thursday",
    "FRIDAY": "Friday",
    "SATURDAY": "Saturday"
  },
  "SLA_REPORTS": {
    "HEADER": "SLA Reports",
    "NO_RECORDS": "SLA applied conversations are not available.",
    "LOADING": "Loading SLA data...",
    "DOWNLOAD_SLA_REPORTS": "Download SLA reports",
    "DOWNLOAD_FAILED": "Failed to download SLA Reports",
    "DROPDOWN": {
      "ADD_FIlTER": "Thêm bộ lọc",
      "CLEAR_ALL": "Clear all",
      "CLEAR_FILTER": "Clear filter",
      "EMPTY_LIST": "Không tìm thấy kết quả",
      "NO_FILTER": "No filters available",
      "SEARCH": "Search filter",
      "INPUT_PLACEHOLDER": {
        "SLA": "SLA name",
        "AGENTS": "Tên tổng đài viên",
        "INBOXES": "Tên kênh",
        "LABELS": "Tên nhãn",
        "TEAMS": "Tên nhóm"
      },
      "SLA": "SLA Policy",
      "INBOXES": "Hộp thư đến",
      "AGENTS": "Nhà cung cấp",
      "LABELS": "Nhãn",
      "TEAMS": "Nhóm"
    },
    "WITH": "with",
    "METRICS": {
      "HIT_RATE": {
        "LABEL": "Hit Rate",
        "TOOLTIP": "Percentage of SLAs created were completed successfully"
      },
      "NO_OF_MISSES": {
        "LABEL": "Number of Misses",
        "TOOLTIP": "Total SLA misses in a certain period"
      },
      "NO_OF_CONVERSATIONS": {
        "LABEL": "Number of Conversations",
        "TOOLTIP": "Total number of conversations with SLA"
      }
    },
    "TABLE": {
      "HEADER": {
        "POLICY": "Policy",
        "CONVERSATION": "Cuộc hội thoại",
        "AGENT": "Nhà cung cấp"
      },
      "VIEW_DETAILS": "View Details"
    }
  },
  "SUMMARY_REPORTS": {
    "SUBTOTAL": "Tổng phụ",
    "NO_TEAM": "Không có nhóm",
    "GROUP_BY_TEAMS": "Nhóm theo nhóm",
    "INBOX": "Hộp thư đến",
    "AGENT": "Nhà cung cấp",
    "TEAM": "Nhóm",
    "LABEL": "Nhãn",
    "TOTAL": "Tổng",
    "AVG_RESOLUTION_TIME": "Avg. Resolution Time",
    "AVG_FIRST_RESPONSE_TIME": "Avg. First Response Time",
    "AVG_REPLY_TIME": "Avg. Customer Waiting Time",
    "RESOLUTION_COUNT": "Số lượng giải quyết",
    "CONVERSATIONS": "Số hội thoại",
    "OUTGOING_CHATS": "Chat đi",
    "OUTGOING_EMAILS": "Email đi",
    "PHONE_CALLS": "Cuộc gọi điện thoại",
    "INBOUND_CALLS": "Cuộc gọi đến",
    "OUTBOUND_CALLS": "Cuộc gọi đi",
    "TOTAL_ACTIVITIES": "Tổng hoạt động",
    "ONLINE_TIME": "Thời gian trực tuyến",
    "QUEUE_AVAILABLE_TIME": "Thời gian sẵn sàng trong hàng đợi",
    "TOOLTIPS": {
      "OUTGOING_CHATS": "Số tin nhắn đi do tổng đài viên này gửi",
      "OUTGOING_EMAILS": "Số email đi do tổng đài viên này gửi",
      "PHONE_CALLS": "Tổng số cuộc gọi được gán cho tổng đài viên này (tổng cuộc gọi đến và đi)",
      "TOTAL_ACTIVITIES": "Tổng số hoạt động: cuộc gọi đến + cuộc gọi đi + chat đi + email đi",
      "INBOUND_CALLS": "Số cuộc gọi đến được gán cho tổng đài viên này",
      "OUTBOUND_CALLS": "Số cuộc gọi đi được gán cho tổng đài viên này",
      "AVG_FIRST_RESPONSE_TIME": "Thời gian trung bình từ khi tạo cuộc hội thoại đến phản hồi đầu tiên của tổng đài viên, trong các cuộc hội thoại được gán cho tổng đài viên này",
      "AVG_RESOLUTION_TIME": "Thời gian trung bình từ khi tạo cuộc hội thoại đến khi giải quyết, trong các cuộc hội thoại được gán cho tổng đài viên này",
      "AVG_REPLY_TIME": "Thời gian trung bình khách hàng chờ giữa tin nhắn của họ và phản hồi của tổng đài viên, trong các cuộc hội thoại được gán cho tổng đài viên này",
      "ONLINE_TIME": "Tổng thời gian tổng đài viên trực tuyến hoặc bận trong khoảng thời gian đã chọn",
      "QUEUE_AVAILABLE_TIME": "Tổng thời gian tổng đài viên sẵn sàng trong hàng đợi điện thoại trong khoảng thời gian đã chọn"
    }
  },
  "PHONE_REPORTS": {
    "HEADER": "Báo cáo Điện thoại",
    "DESCRIPTION": "Theo dõi các chỉ số cuộc gọi điện thoại với thông tin chi tiết về cuộc gọi đến và đi, được nhóm theo tổng đài viên hoặc hộp thư đến để phân tích toàn diện.",
    "DOWNLOAD_PHONE_REPORTS": "Tải xuống Báo cáo Điện thoại",
    "GROUP_BY": {
      "LABEL": "Nhóm theo",
      "AGENT": "Nhà cung cấp",
      "INBOX": "Hộp thư đến"
    },
    "TABLE": {
      "TOTAL_CALLS": "Tổng",
      "INBOUND_CALLS": "Gọi đến",
      "OUTBOUND_CALLS": "Gọi đi",
      "FAILED_OUTBOUND_CALLS": "Gọi đi thất bại",
      "AVG_AGENT_HANDLED_DURATION": "Thời lượng TB",
      "TOTAL_AGENT_HANDLED_DURATION": "Tổng thời lượng",
      "AVG_RINGING_TIME": "TG đổ chuông TB",
      "CONNECTED_OUTBOUND_PERCENTAGE": "% Thành công",
      "UNIQUE_CALLERS": "Người gọi riêng biệt",
      "UNIQUE_CALLED_CONTACTS": "Số gọi riêng biệt",
      "UNANSWERED_MISSED_CALLS": "Nhỡ không theo dõi",
      "UNANSWERED_MISSED_PERCENTAGE": "% Nhỡ không theo dõi",
      "INSUFFICIENTLY_HANDLED_UNANSWERED_MISSED_CALLS": "Nhỡ không theo dõi, gọi lại chưa đủ",
      "INSUFFICIENTLY_HANDLED_UNANSWERED_MISSED_PERCENTAGE": "% Nhỡ không theo dõi, gọi lại chưa đủ"
    },
    "TOOLTIPS": {
      "TOTAL_CALLS": "Tổng số tất cả cuộc gọi (kể cả không kết nối được)",
      "INBOUND_CALLS": "Số cuộc gọi đã kết nối",
      "OUTBOUND_CALLS": "Tổng số cuộc gọi đi (kể cả không kết nối được)",
      "FAILED_OUTBOUND_CALLS": "Số cuộc gọi đi không kết nối được",
      "AVG_AGENT_HANDLED_DURATION": "Thời lượng trung bình của các cuộc gọi do tổng đài viên xử lý",
      "TOTAL_AGENT_HANDLED_DURATION": "Tổng thời lượng của tất cả cuộc gọi do tổng đài viên xử lý",
      "AVG_RINGING_TIME": "Thời gian đổ chuông trung bình trước khi cuộc gọi được trả lời",
      "CONNECTED_OUTBOUND_PERCENTAGE": "Tỷ lệ phần trăm cuộc gọi đi kết nối thành công",
      "UNIQUE_CALLERS": "Số liên hệ riêng biệt đã gọi đến",
      "UNIQUE_CALLED_CONTACTS": "Số liên hệ riêng biệt được gọi đi",
      "UNANSWERED_MISSED_CALLS": "Số cuộc gọi nhỡ chưa được gọi lại thành công (kết nối được). Có thể bao gồm các cuộc gọi vẫn có thể xử lý trong ngày làm việc",
      "UNANSWERED_MISSED_PERCENTAGE": "Tỷ lệ phần trăm người gọi riêng biệt có cuộc gọi bị nhỡ mà không được theo dõi (cuộc gọi nhỡ không theo dõi / người gọi riêng biệt)",
      "INSUFFICIENTLY_HANDLED_UNANSWERED_MISSED_CALLS": "Số cuộc gọi nhỡ có ít hơn 2 lần gọi lại. Có thể bao gồm các cuộc gọi vẫn có thể xử lý trong ngày làm việc",
      "INSUFFICIENTLY_HANDLED_UNANSWERED_MISSED_PERCENTAGE": "Tỷ lệ phần trăm người gọi riêng biệt có ít hơn 2 lần gọi lại ((nhỡ không theo dõi - đã xử lý đủ) / người gọi riêng biệt)"
    }
  }
}
